import {useContext} from "react";
import {TranslateContext} from "../../../context/TranslateContext";
import {AuthContext} from "../../../context/AuthContext";
import {useHistory} from "react-router-dom";
import {MobileContext} from "../../../context/MobileContext";
import NsMenuUtenteView from "./NsMenuUtenteView";

export default function NsMenuUtenteController({
                                                   refMenuUsr,
                                                   anni,
                                               }) {

    const history = useHistory();

    const {setLingua} = useContext(TranslateContext);
    const {user, handleLogout, annoKpi, setAnnoKpi} = useContext(AuthContext);
    const {isMobile} = useContext(MobileContext);

    function aggiornaLingua(lingua) {
        setLingua(lingua);
    }

    function onChangeAnno(event) {
        setAnnoKpi(event.target.value);
    }

    function onClickLogout() {
        handleLogout();
        history.push('/');
    }

    return (
        <NsMenuUtenteView
            isMobile={isMobile}
            anni={anni}
            refMenuUsr={refMenuUsr}
            annoKpi={annoKpi}
            user={user}
            aggiornaLingua={aggiornaLingua}
            onChangeAnno={onChangeAnno}
            onClickLogout={onClickLogout}
        />
    );
}